// import '@webcomponents/webcomponentsjs' // IE11 web component support
import '../file/iconPark' // IconPark 的图标 js 文件
import '../file/iconPark1' // IconPark 的图标 js 文件

import { Tooltip } from 'antd'
import React from 'react'

export default function EKBIconPark(props) {
  let { name, className = '', style = {}, onClick, tooltipTitle, placement } = props
  let handleOnClick = e => {
    onClick && onClick(e)
  }
  let newName = name
  if (typeof name === 'object') {
    //扩展中心列表里面，第三方平台添加的应用图标需要根据fileId查询出对象
    newName = name.thumbUrl
  }
  let comp = (
    <iconpark-icon
      class={`icon ${className}`}
      style={style}
      color="currentColor"
      fill="currentColor"
      stroke="currentColor"
      name={newName}
      onClick={handleOnClick}
    ></iconpark-icon>
  )
  if (/^http/.test(newName)) {
    comp = <img src={newName} className={`icon ${className}`} style={style} onClick={handleOnClick} />
  }

  if (tooltipTitle && tooltipTitle.length) {
    return (
      <Tooltip title={tooltipTitle} placement={placement}>
        {comp}
      </Tooltip>
    )
  }
  return comp
}
